module.exports = __webpack_public_path__ + "img/phone-solid.584f89de.svg";